export class GlobalizeLoaderService {
    static $inject: string[] = [
        'BASE_PATH',
    ];

    constructor(private BASE_PATH) {

    }

    loadGlobalizeScript(culture: string) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `${this.BASE_PATH}/js/cultures/globalize.culture.${culture}-min.js`;
        document.body.appendChild(script);
    }
}
